<div class="client-container">
    <div class="page-top-banner">
        <div class="title">{{ isEditMode ? 'Modifier un client' : 'Créer un client' }}</div>
    </div>

    <form [formGroup]="form" class="form-content">
        <mat-tab-group>
            <mat-tab label="Informations générales">
                <mat-card class="box dark-card">
                    <div class="form-grid">

                        <mat-checkbox [checked]="formEnabled" (change)="onEnabledChanged($event.checked)">
                            Client actif
                        </mat-checkbox>

                        <mat-form-field appearance="fill">
                            <mat-label>Nom de l'entreprise</mat-label>
                            <input matInput formControlName="nom" />
                        </mat-form-field>

                        <mat-form-field appearance="fill">
                            <mat-label>SIRET / SIREN</mat-label>
                            <input matInput formControlName="siret" />
                        </mat-form-field>

                        <mat-form-field appearance="fill">
                            <mat-label>Email de contact</mat-label>
                            <input matInput formControlName="email" type="email" />
                        </mat-form-field>

                        <mat-form-field appearance="fill">
                            <mat-label>Téléphone</mat-label>
                            <input matInput formControlName="phone" />
                        </mat-form-field>

                        <mat-form-field appearance="fill">
                            <mat-label>Adresse</mat-label>
                            <input matInput formControlName="address" />
                        </mat-form-field>

                        <mat-form-field appearance="fill">
                            <mat-label>Code postal</mat-label>
                            <input matInput formControlName="zipcode" />
                        </mat-form-field>

                        <mat-form-field appearance="fill">
                            <mat-label>Ville</mat-label>
                            <input matInput formControlName="city" />
                        </mat-form-field>

                        <mat-form-field appearance="fill">
                            <mat-label>Pays</mat-label>
                            <input matInput formControlName="country" />
                        </mat-form-field>

                    </div>
                </mat-card>
            </mat-tab>
        </mat-tab-group>

        <div class="buttons-band">
            <button mat-stroked-button class="accent-button" type="button" (click)="cancel()">
                Annuler
            </button>
            <button mat-raised-button class="accent-button" type="submit" (click)="submit()" [disabled]="form.invalid">
                {{ isEditMode ? 'Enregistrer' : 'Créer' }}
            </button>
        </div>
    </form>
</div>